var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12.5H1.66667C1.22464 12.5 0.800716 12.6756 0.488155 12.9882C0.175595 13.3007 0 13.7246 0 14.1667L0 25.8333C0 26.2754 0.175595 26.6993 0.488155 27.0118C0.800716 27.3244 1.22464 27.5 1.66667 27.5H3.33333C3.55435 27.5 3.76631 27.4122 3.92259 27.2559C4.07887 27.0996 4.16667 26.8877 4.16667 26.6667V13.3333C4.16667 13.1123 4.07887 12.9004 3.92259 12.7441C3.76631 12.5878 3.55435 12.5 3.33333 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 9.16669H7.50016C7.05814 9.16669 6.63421 9.34228 6.32165 9.65484C6.00909 9.9674 5.8335 10.3913 5.8335 10.8334V29.1667C5.8335 29.6087 6.00909 30.0326 6.32165 30.3452C6.63421 30.6578 7.05814 30.8334 7.50016 30.8334H11.6668C11.8878 30.8334 12.0998 30.7456 12.2561 30.5893C12.4124 30.433 12.5002 30.221 12.5002 30V10C12.5002 9.77901 12.4124 9.56705 12.2561 9.41076C12.0998 9.25448 11.8878 9.16669 11.6668 9.16669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3335 12.5H36.6668C36.4458 12.5 36.2339 12.5878 36.0776 12.7441C35.9213 12.9004 35.8335 13.1123 35.8335 13.3333V26.6667C35.8335 26.8877 35.9213 27.0996 36.0776 27.2559C36.2339 27.4122 36.4458 27.5 36.6668 27.5H38.3335C38.7755 27.5 39.1994 27.3244 39.512 27.0118C39.8246 26.6993 40.0002 26.2754 40.0002 25.8333V14.1667C40.0002 13.7246 39.8246 13.3007 39.512 12.9882C39.1994 12.6756 38.7755 12.5 38.3335 12.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 9.16669H28.3333C28.1123 9.16669 27.9004 9.25448 27.7441 9.41076C27.5878 9.56705 27.5 9.77901 27.5 10V30C27.5 30.221 27.5878 30.433 27.7441 30.5893C27.9004 30.7456 28.1123 30.8334 28.3333 30.8334H32.5C32.942 30.8334 33.366 30.6578 33.6785 30.3452C33.9911 30.0326 34.1667 29.6087 34.1667 29.1667V10.8334C34.1667 10.3913 33.9911 9.9674 33.6785 9.65484C33.366 9.34228 32.942 9.16669 32.5 9.16669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 17.5H14.9998C14.5396 17.5 14.1665 17.8731 14.1665 18.3333V21.6667C14.1665 22.1269 14.5396 22.5 14.9998 22.5H24.9998C25.4601 22.5 25.8332 22.1269 25.8332 21.6667V18.3333C25.8332 17.8731 25.4601 17.5 24.9998 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1);
export default __webpack_public_path__ + "static/media/feature1.6592e7acc3eeb19c4d8598b835c6ff77.svg";
export { ForwardRef as ReactComponent };